// extracted by mini-css-extract-plugin
export default {"primaryBtn":"PrimaryButton_primaryBtn__en8ql"};